import React, { useContext, useEffect, useState } from "react";
import { Grid, Box, Typography } from "@mui/material";
import httpRequest from "../../httpRequest";
import InvoiceStatusDistributionCard from "../../components/InvoiceStatusDistributionCard";
import InvoiceStatusDistributionCardApproved from "../../components/InvoiceStatusDistributionCardApproved";
import TopSuppliersCard from "../../components/TopSuppliersCard";
import RecentScansCard from "../../components/RecentScansCard";
import ScanAccuracyRateCard from "../../components/ScanAccuracyRateCard";
import TotalSpendBySupplierCard from "../../components/TotalSpendBySupplierCard";
import InvoiceTimelineCard from "../../components/InvoiceTimelineCard";
import InvoiceAmountDistributionCard from "../../components/InvoiceAmountDistributionCard";
import MyInvoicesCard from "../../components/MyInvoicesCard";

import QuickTiles from "../../components/QuickTiles";
import userContext from "../../context/user-context";
import AppLayout from "../../components/AppLayout/AppLayout";
import Homebar from "../../components/Homebar/Homebar";
import ExpenseStatusDistributionCard from "../../components/ExpenseStatusDistributionCard";
import ExpenseStatusDistributionCardApproved from "../../components/ExpenseStatusDistributionCardApproved";
import FrequentReimbursementClaimantsCard from "../../components/FrequentReimbursementClaimantsCard";
import ExpenseAmountDistributionCard from "../../components/ExpenseAmountDistributionCard";
import ExpenseInboxCard from "../../components/ExpenseInboxCard";
import MyExpensesCard from "../../components/MyExpensesCard";

const Homepage = () => {
  const [rawInvoiceData, setRawInvoiceData] = useState([]);
  const [rawExpenseData, setRawExpenseData] = useState([]);


  const userCtx = useContext(userContext); // Access user context directly
  const { overriddenRole, employeeCode } = userCtx; // Destructure needed fields from context


  useEffect(() => {
    fetchInvoiceData();
    fetchExpenseData();
  }, []);

  const fetchInvoiceData = async () => {
    try {
      const resp = await httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/get-invoices?exclude_fields=pdf_file,image_file`);
      setRawInvoiceData(resp.data.invoices);
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  };

  const fetchExpenseData = async () => {
    try {
      const resp = await httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/get-expenses?exclude_fields=expenses`);
      setRawExpenseData(resp.data.expenses);
    } catch (error) {
      console.error("Error fetching expenses:", error);
    }
  };

  const renderContentBasedOnTab = (activeTab) => {
    switch (activeTab) {
      case 0: // Invoicing Overview
        return (
          <>
            <Grid item xs={12} sm={6} md={4} textAlign="center">
              <InvoiceStatusDistributionCard invoiceData={rawInvoiceData} />
            </Grid>
            <Grid item xs={12} sm={6} md={4} textAlign="center">
              <InvoiceStatusDistributionCardApproved invoiceData={rawInvoiceData} />
            </Grid>
            <Grid item xs={12} sm={6} md={4} textAlign="center">
              <TopSuppliersCard invoiceData={rawInvoiceData} />
            </Grid>
            <Grid item xs={12} sm={6} md={6} textAlign="center">
              <RecentScansCard invoiceData={rawInvoiceData} />
            </Grid>
           {employeeCode === "admin" ? (
          <Grid item xs={12} sm={6} md={6} textAlign="center">
            <ScanAccuracyRateCard />
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={6} textAlign="center">
           <MyInvoicesCard />
          </Grid>
        )}
            <Grid item xs={12} sm={6} md={6} textAlign="center">
              <InvoiceTimelineCard invoiceData={rawInvoiceData} />
            </Grid>
            <Grid item xs={12} sm={6} md={6} textAlign="center">
              <TotalSpendBySupplierCard invoiceData={rawInvoiceData} />
            </Grid>  
            <Grid item xs={12} sm={12} md={12} textAlign="center">
              <InvoiceAmountDistributionCard invoiceData={rawInvoiceData} />
            </Grid>
          </>
        );
      case 2: // Employee Expense Reimbursement
        return (
          <>
           <Grid item xs={12} sm={6} md={4} textAlign="center">
                          <ExpenseStatusDistributionCard expenseData={rawExpenseData} />
          </Grid>
          <Grid item xs={12} sm={6} md={4} textAlign="center">
          <ExpenseStatusDistributionCardApproved expenseData={rawExpenseData} />

            </Grid>
            <Grid item xs={12} sm={6} md={4} textAlign="center">
              <FrequentReimbursementClaimantsCard expenseData={rawExpenseData} />
            </Grid>  <Grid item xs={12} sm={3} md={3} textAlign="center">
           <MyExpensesCard  />
          </Grid>
            <Grid item xs={12} sm={9} md={9} textAlign="center">
           <ExpenseInboxCard />
          </Grid>
            <Grid item xs={12} sm={12} md={12} textAlign="center">
              <ExpenseAmountDistributionCard expenseData={rawExpenseData} />
            </Grid>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <AppLayout userName={userCtx.userName}>
      {(handleTabChange, activeTab) => (
        <>
          <Homebar activeTab={activeTab} handleTabChange={handleTabChange} />
          <Box sx={{ padding: '0 30px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
              <QuickTiles currentUser={userCtx} activeTab={activeTab} />
              </Grid>
              {renderContentBasedOnTab(activeTab)}
            </Grid>
          </Box>
        </>
      )}
    </AppLayout>
  );
};

export default Homepage;
